export default __webpack_public_path__ + "static/media/cancer_banner_Cn.95cbcd1d.webp";